import { DialogProps } from '@mui/material';
import { PropsWithChildren, createContext, useContext } from 'react';

export type BaseDialogProps = Pick<DialogProps, 'hideBackdrop' | 'container' | 'sx'>;

const DialogPropsContext = createContext<BaseDialogProps>({});

export function useDialogPropsContext(): BaseDialogProps {
  return useContext(DialogPropsContext);
}

interface DialogPropsProviderProps {
  readonly baseDialogProps: BaseDialogProps;
}

export function DialogPropsProvider({
  baseDialogProps: baseDialogProps,
  children,
}: PropsWithChildren<DialogPropsProviderProps>) {
  return (
    <DialogPropsContext.Provider value={baseDialogProps}>{children}</DialogPropsContext.Provider>
  );
}
